export default __webpack_public_path__ + "static/media/hht1_ep15_minisitcom_03.33928bbd.png";